// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"eab292b7","279":"462def3a"}[chunkId] + ".chunk.js";
};